/* eslint-disable no-underscore-dangle, no-use-before-define, no-restricted-syntax, no-param-reassign */

const inflateReal = (node, index, path) => {
  if (node && node.id && node.__typename) {
    const route = path.join(',');

    if (
      index[route] &&
      index[route][node.__typename] &&
      index[route][node.__typename][node.id]
    ) {
      return index[route][node.__typename][node.id];
    }

    if (!index[route]) {
      index[route] = {};
    }

    if (!index[route][node.__typename]) {
      index[route][node.__typename] = {};
    }

    index[route][node.__typename][node.id] = node;
  }

  const fieldNames = Object.keys(node);

  const result = Array.isArray(node) ? [] : {};

  for (const fieldName of fieldNames) {
    const value = node[fieldName];

    if (Array.isArray(value)) {
      result[fieldName] = value.map(childNode => {
        if (typeof childNode === 'string') {
          return childNode;
        }

        return inflate(childNode);
      });
    } else if (typeof value === 'object' && value !== null) {
      result[fieldName] = inflate(value);
    } else {
      result[fieldName] = value;
    }
  }

  return result;
};
/* eslint-enable no-underscore-dangle, no-use-before-define, no-restricted-syntax, no-param-reassign */

const inflate = response => {
  if (typeof response !== 'object') {
    return response;
  }

  const index = {};

  return inflateReal(response, index, []);
};

export default inflate;
